export default __webpack_public_path__ + "static/media/icon-add-person.81117c84.svg";